import { render } from "./recomendadosComponent.vue?vue&type=template&id=408f0f23"
import script from "./recomendadosComponent.vue?vue&type=script&lang=js"
export * from "./recomendadosComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__